import { c as r } from "./ghl-ui.es384.js";
import i from "./ghl-ui.es1158.js";
const {
  cubicBezierEaseIn: a,
  cubicBezierEaseOut: s
} = i;
function m({
  duration: n = "0.3s",
  leaveDuration: o = "0.2s",
  name: t = "slide-in-from-top"
} = {}) {
  return [r(`&.${t}-transition-leave-active`, {
    transition: `transform ${o} ${a}`
  }), r(`&.${t}-transition-enter-active`, {
    transition: `transform ${n} ${s}`
  }), r(`&.${t}-transition-enter-to`, {
    transform: "translateY(0)"
  }), r(`&.${t}-transition-enter-from`, {
    transform: "translateY(-100%)"
  }), r(`&.${t}-transition-leave-from`, {
    transform: "translateY(0)"
  }), r(`&.${t}-transition-leave-to`, {
    transform: "translateY(-100%)"
  })];
}
export {
  m as slideInFromTopTransition
};
